// tslint:disable-next-line:max-line-length
import { Component, ViewChild, Input, Output, EventEmitter,  LOCALE_ID, Inject  } from '@angular/core';
import { MetadataService } from '../../metadata.service';
import { MetadatapackageselectComponent } from '../metadatapackageselect/metadatapackageselect.component';
import { Metadata4RefDto, MetadataPackageHeader } from '../../../metadata4refdto';
import { GSPMetadataService } from '../../../metadata.service';
import { LoadingService } from '@farris/ui-loading';
import {MessagerService} from '@farris/ui-messager';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-select-metadata',
  templateUrl: './selectmetadata.component.html',
  styleUrls: ['./selectmetadata.component.css']
})
export class SelectMetadataComponent {
  @ViewChild(MetadatapackageselectComponent) metadatapackageselectComponent: MetadatapackageselectComponent;
  @Input() metadataPath: string;
  @Input() typeName: string;
  @Input() filter: string;
  @Input() onlyDisplayCurrentProject: boolean;
  classifier: any;
  // 技术栈
  codelanguage: string;
  // 是否开启maven引用
  isMavenEnable: boolean;
  metadata: any;
  @Output() closeModalEmitter: EventEmitter<any>;
  @Output() selectedMetadata = new EventEmitter<any>();

  public LOCALES = {
    en: {
      "confirm": "OK",
      "cancel": "Cancel",
      "selectFirst": "Please select the metadata first.",
      "noMetadataPackage": "Metadata package information not found.",
      "noRepositoryInfo": "Repository information not found.",
      "referenceFailed": "Failed to reference metadata.",
      "acrossSUWarning": "The selected metadata does not belong to the current SU. Continue?",
      "pleaseSelectMetadata": "Please select a metadata first.",
      "loadingMessage": "Adding reference, please wait...",
      "pleaseWait": "Please wait..."
    },
    "zh-CHS": {
      "confirm": "确定",
      "cancel": "取消",
      "selectFirst": "请先选中元数据。",
      "noMetadataPackage": "未找到元数据包信息。",
      "noRepositoryInfo": "未找到仓库信息。",
      "referenceFailed": "引用元数据失败。",
      "acrossSUWarning": "选中的元数据不属于当前SU, 是否继续？",
      "pleaseSelectMetadata": "请先选中一个元数据。",
      "loadingMessage": "正在添加引用，请稍候...",
      "pleaseWait": "请稍候..."
    },
    "zh-CHT": {
      "confirm": "確定",
      "cancel": "取消",
      "selectFirst": "請先選取元數據。",
      "noMetadataPackage": "未找到元數據包信息。",
      "noRepositoryInfo": "未找到倉庫信息。",
      "referenceFailed": "引用元數據失敗。",
      "acrossSUWarning": "選中的元數據不屬於當前SU, 是否繼續？",
      "pleaseSelectMetadata": "請先選中一個元數據。",
      "loadingMessage": "正在添加引用，請稍候...",
      "pleaseWait": "請稍候..."
    }
  };
  localeData = null;

  constructor(private metadataService: MetadataService,
              private loading: LoadingService,
              private gspMetaService: GSPMetadataService,
              private msgService: MessagerService,
              @Inject(LOCALE_ID) private localeID: string) {
    this.localeID = localStorage.getItem('languageCode')  || 'zh-CHS';
    this.localeData = this.LOCALES[this.localeID];
    this.closeModalEmitter = new EventEmitter<any>();
    this.metadataService.selectedChange.subscribe(leftItem => {
      this.classifier = leftItem;
    });
    this.isMavenEnable = false;
    this.gspMetaService.getMavenSetting().subscribe(flag => {
      // if (flag) {
        this.isMavenEnable = flag;
      // }
    });
  }
  onSelectedMetadataChanged(metadata) {
    this.metadata = metadata;
  }

  setCodeLanguage(code: string) {
    this.codelanguage = code;
  }

  LoadMetadata() {
    if (this.metadata && this.classifier) {
      // 选中的是当前工程下的元数据，调用Load
      if (this.classifier.id === 'project' || this.classifier.id === 'bo') {
        if (this.loading) { this.loading.show({ message: this.localeData.loadingMessage }); }
        this.metadataService.LoadTheMetadata(this.metadata).subscribe(templates => {
          if (this.loading) { this.loading.close(); }
          const metadata4Ref = new Metadata4RefDto();
          metadata4Ref.metadata = templates;
          metadata4Ref.metadata.processMode = this.metadata.processMode === 'interpretation' ? 'interpretation' : 'generation';
          metadata4Ref.packageHeader = new MetadataPackageHeader();
          this.selectedMetadata.emit(metadata4Ref);
          this.hideModal();
        }, error => {
          this.errorMsg(error);
          if (this.loading) { this.loading.close(); }
        }, () => {
          if (this.loading) { this.loading.close(); }
        });
      } else if (this.classifier.id === 'local') {
        if (!this.metadata.mdPkgName) {
          const msg = this.localeData.noMetadataPackage;
          gsp.ide.messager.error(msg);
          return;
        }
        if (this.loading) { this.loading.show({ message: this.localeData.loadingMessage }); }
        this.metadataService.pickMetadataIndex(1, this.metadata, this.codelanguage, this.isMavenEnable).subscribe(templates => {
          if (this.loading) { this.loading.close(); }
          templates.metadata.processMode = this.metadata.processMode === 'interpretation' ? 'interpretation' : 'generation';
          this.selectedMetadata.emit(templates);
          this.hideModal();
        }, error => {
          this.errorMsg(error);
          if (this.loading) { this.loading.close(); }
        }, () => {
          if (this.loading) { this.loading.close(); }
        });
      } else if (this.classifier.id === 'remote') {
        if (!this.metadata.mdPkgName) {
          const msg = this.localeData.noMetadataPackage;
          gsp.ide.messager.error(msg);
          return;
        }
        if (!this.metadata.repoPkg || this.metadata.repoPkg.length < 1) {
          const msg = this.localeData.noRepositoryInfo;
          gsp.ide.messager.error(msg);
          return;
        }
        if (this.loading) { this.loading.show({ message: this.localeData.loadingMessage }); }
        this.metadataService.pickMetadataIndex(2, this.metadata, this.codelanguage, this.isMavenEnable).subscribe(templates => {
          if (this.loading) { this.loading.close(); }
          templates.metadata.processMode = this.metadata.processMode === 'interpretation' ? 'interpretation' : 'generation';
          this.selectedMetadata.emit(templates);
          this.hideModal();
        }, error => {
          this.errorMsg(error);
          if (this.loading) { this.loading.close(); }
        }, () => {
          if (this.loading) { this.loading.close(); }
        });
      } else if (this.classifier.id === 'ref') {
        if (!this.metadata.mdPkgName) {
          const msg = this.localeData.noMetadataPackage;
          gsp.ide.messager.error(msg);
          return;
        }
        if (!this.metadata.repoPkg || this.metadata.repoPkg.length < 1) {
          const msg = this.localeData.noRepositoryInfo;
          gsp.ide.messager.error(msg);
          return;
        }
        if (this.loading) { this.loading.show({ message: this.localeData.pleaseWait }); }
        this.metadataService.pickMetadataIndex(3, this.metadata, this.codelanguage, this.isMavenEnable).subscribe(templates => {
          if (this.loading) { this.loading.close(); }
          templates.metadata.processMode = this.metadata.processMode === 'interpretation' ? 'interpretation' : 'generation';
          this.selectedMetadata.emit(templates);
          this.hideModal();
        }, error => {
          this.errorMsg(error);
          if (this.loading) { this.loading.close(); }
        }, () => {
          if (this.loading) { this.loading.close(); }
        });
      } else if (this.classifier.id === 'db') {
        if (this.loading) { this.loading.show({ message: this.localeData.loadingMessage }); }
        this.metadataService.pickMetadataIndex(4, this.metadata, this.codelanguage, this.isMavenEnable).subscribe(templates => {
          if (this.loading) { this.loading.close(); }
          if (templates.isAcrossSU && templates.isAcrossSU === true) {
            if(this.msgService) {
               this.msgService.confirm(this.localeData.acrossSUWarning).subscribe(res => {
                if ( res ) {
                  templates.metadata.processMode = this.metadata.processMode === 'interpretation' ? 'interpretation' : 'generation';
                  this.selectedMetadata.emit(templates);
                  this.hideModal();
                  }
              });
            } else {
              var res = window.confirm(this.localeData.acrossSUWarning);
              if ( res ) {
                templates.metadata.processMode = this.metadata.processMode === 'interpretation' ? 'interpretation' : 'generation';
                this.selectedMetadata.emit(templates);
                this.hideModal();
                }
            }
          } else {
            templates.metadata.processMode = this.metadata.processMode === 'interpretation' ? 'interpretation' : 'generation';
            this.selectedMetadata.emit(templates);
            this.hideModal();
          }
        }, error => {
          this.errorMsg(error);
          if (this.loading) { this.loading.close(); }
        }, () => {
          if (this.loading) { this.loading.close(); }
        });
      }
    } else {
      const msg = this.localeData.pleaseSelectMetadata;
      gsp.ide.messager.warning(msg);
    }
  }

  private errorMsg(error) {
    let msg = error.error.Message !== undefined ? error.error.Message : error.error.error.message;
    if (msg == null) {
      msg = this.localeData.referenceFailed;
    }
    gsp.ide.messager.error(msg);
  }

  // 弹出元数据包选择界面
  PackageSelect() {
    this.metadatapackageselectComponent.showModal();
  }
  hideModal(): void {
    this.closeModalEmitter.emit();
  }
}
